<div class="reports-table-container" (scroll)="onScroll($event)">
  <uv-table class="report-table" testID="2" #dt [columns]="cols" [value]="entries" [resizableColumns]="true" [scrollable]="true"
    scrollHeight="calc(75vh)" [(first)]="firstPage" [customSort]="true" [tableStyle]="{'width': '100%'}"
    (contextmenu)="cm.show($event)" (sortFunction)="doCustomSort($event)" [virtualScroll]="true"
    [virtualScrollItemSize]="VirtualScrollItemSize">

    <ng-template pTemplate="caption">
      <button type="button" pButton icon="fa fa-file-o" iconPos="left" label="Export"
      (click)="dt.exportCSV()"></button>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        @for (col of cols; track col) {
          <th uvResizableColumn [uvSortableColumn]="col.field">
            {{col.header}}
            <uv-sortIcon [field]="col.field"></uv-sortIcon>
          </th>
        }
      </tr>
      <tr>
        @for (col of cols; track col) {
          <th>
            <input pInputText type="text" style="width: 100%;"
              (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)">
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData>
        <tr [style]="TableRowStyle" [uvSelectableRow]="rowData">
          @for (col of cols; track col) {
            <td [class]="cellClasses(col.field, rowData)">
              <span class="uv-table-value">{{ rowData[col.field] }}</span>
            </td>
          }
        </tr>
      </ng-template>

    </uv-table>

    <p-contextMenu #cm [model]="cmItems" appendTo="body"></p-contextMenu>

    <p-dialog [(visible)]="displaySelectColumnsDialog" class="infoset-column-selector" [resizable]="false"
      (onHide)="onSelectColumnsDialogHide()">

      <p-header>
        <span>Select Columns</span>
      </p-header>

      <p-listbox [options]="selectItems" [(ngModel)]="cols" multiple="multiple" checkbox="checkbox"
      (onChange)="onColumnSelectionChange($event)"></p-listbox>

      <p-footer>
        <button type="button" pButton icon="fa fa-times" (click)="closeSelectColumnsDialog()"
        label="Close"></button>
      </p-footer>

    </p-dialog>

  </div>
